const auctionFilter = (auctions, searchTerm) => {
  if (!searchTerm.trim()) return auctions

  const searchTerms = searchTerm.toLowerCase().split(/\s+/)

  const matchesFilter = (auction, field, term) => {
    return auction[field]?.toString().toLowerCase().includes(term)
  }

  return auctions.filter((auction) => {
    return searchTerms.every((term) => {
      return (
        matchesFilter(auction, 'name', term) ||
        matchesFilter(auction, 'address', term) ||
        matchesFilter(auction, 'city', term) ||
        matchesFilter(auction, 'state', term) ||
        matchesFilter(auction, 'postal_code', term)
      )
    })
  })
}

export default auctionFilter
